import { api } from './api';

export const getPayRoll = async (addUrl='') =>{  
    let url=`payroll/list?${addUrl}`;
  return await api.get(url);
};


